package app.nestbridge.feature.designcatalog.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

/**
 * Internal-only screen hosting the Karawek / NestBridge design system catalog.
 * Not user-facing.
 */
@Parcelize
data object DesignCatalogScreen : Screen

data class DesignCatalogState(
    val eventSink: (DesignCatalogEvent) -> Unit,
) : CircuitUiState

sealed interface DesignCatalogEvent {
    data object BackClicked : DesignCatalogEvent
}
